export default __webpack_public_path__ + "static/media/androidWhite.2136501b.svg";